


















import { PropType, toRef, getCurrentInstance, watch } from 'vue';
import { PostModel } from '../../../shared/models/post.model';
import Post from './Post.vue';
import { useDelayedVisibilityMarking } from '../../../shared/composables/useDelayedVisibilityMarking';
import { notificationAreas } from '../../../shared/enums/notificationAreas';
import { notificationEventTypes } from '../../../shared/enums/notificationEventTypes';
import { types } from '../../store/types/types.js';
import { NotificationModel } from '../../../shared/models/notification.model';
import { usePosts } from '../../../shared/composables/usePosts';

export default {
  components: { Post },
  props: {
    posts: { type: Array as PropType<PostModel[]>, required: true },
    notifications: { type: Array as PropType<NotificationModel[]>, default: () => [] },
  },
  emits: ['edit', 'delete', 'report', 'post-marked-read'],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const posts = toRef(props, 'posts');
    const notificationsRef = toRef(props, 'notifications');
    const { posts: displayedPosts, assignPosts, toggleBookmark } = usePosts();

    const handleToggleBookmark = async (post: PostModel) => {
      await toggleBookmark(post);
      const toastMessage = (
        post.isBookmarked ? proxy.$t('post.post_bookmarked') : proxy.$t('post.post_unbookmarked')
      ).toString();
      proxy.$showToast(toastMessage);
    };

    const getNewPostNotifications = postId =>
      notificationsRef.value
        .filter(
          notification =>
            notification.notificationArea === notificationAreas.POSTS &&
            notification.postId == postId &&
            notification.notificationEventType === notificationEventTypes.POST_SHARED_WITH_ME
        )
        .map(notification => ({
          notificationId: notification.notificationId,
          institutionProfileId: notification.institutionProfileId,
        }));

    const markPostAsRead = postId => {
      const postNotifications = getNewPostNotifications(postId);
      if (postNotifications.length > 0) {
        proxy.$store.dispatch(types.DELETE_NOTIFICATIONS, { notifications: postNotifications });
        emit('post-marked-read', postId);
      }
    };

    const { itemRefs: postRefs } = useDelayedVisibilityMarking(posts, markPostAsRead);

    const emitEdit = postId => {
      emit('edit', postId);
    };

    const emitDelete = postId => {
      emit('delete', postId);
    };

    const emitReport = postId => {
      emit('report', postId);
    };

    watch(
      () => props.posts,
      () => {
        assignPosts(props.posts);
      },
      { immediate: true }
    );

    return {
      postRefs,
      displayedPosts,
      emitEdit,
      emitDelete,
      emitReport,
      handleToggleBookmark,
    };
  },
};
